import { APP_BASE_PATH } from '../../../common/constants'

const TITLE =
  'Important Information for Freedom Debt Relief Clients | Freedom Debt Relief'
const DESCRIPTION =
  'Want to know how Freedom Debt Relief works? How much money you could save? Do you need to pay up-front fees? Our FAQs answer those and more.Click this link!'
const URL = `${APP_BASE_PATH()}/client-faq/`

export const SEO = {
  title: TITLE,
  description: DESCRIPTION,
  canonical: URL,
  openGraph: {
    title: TITLE,
    description: DESCRIPTION,
    url: URL,
    locale: 'en_US',
    type: 'article',
    article: {
      modifiedTime: '2019-10-01T23:13:54+00:00',
      authors: ['https://www.facebook.com/freedomdebtrelief'],
    },
  },
}

export const PAGE_DATA = {
  title: 'Important Information for Freedom Debt Relief Clients',
  subTitle: 'AGREEMENT WITH THE CONSUMER FINANCIAL PROTECTION BUREAU',
  blueSectionData:
    'Freedom Debt Relief has been in the news lately, so we want to make sure that you, our valued client, know the facts. More than ever, we want you to know that we remain committed to helping people take control of their finances and get out of debt, as we have since 2002. Of course, we understand if you have a few questions.',
  textContent: `July 9, 2019 — Freedom Debt Relief has settled the case filed by the Consumer Financial Protection Bureau (CFPB) in November 2017. Over the past year and a half, we have worked closely with the Bureau to address their concerns, provide insights into our debt relief program, and to ensure that we continue to serve our clients. In resolving the case, we have agreed to make some changes to our disclosures and policies to enhance our program, many of which were implemented when the case was first filed.

  Since 2002, Freedom Debt Relief has been committed to helping consumers who are struggling with debt to take control of their finances and get on a path to financial wellness. Moving forward, we will continue to work alongside the CFPB as an industry partner to support their work, particularly in the consumer debt space. As the leader in debt settlement, we continue to work hard every day to deliver outstanding service and the best possible outcomes to consumers who turn to us for help.`,
}
